/** Shared Ecotrack carrier definitions — used by Livraison + Ecotrack dashboards. */

export const ecotrackApiFields = (defaultUrl) => [
  {
    infoKey: 'api_id',
    idType: 'url',
    label: 'URL API',
    placeholder: defaultUrl,
    password: false,
    readOnly: true,
  },
  { infoKey: 'api_token', label: 'Token API', placeholder: '••••••••', password: true },
];

export const ECOTRACK_CARRIERS = [
  {
    id: 'Colizone',
    name: 'Colizone',
    apiSlug: 'colizone',
    apiBase: 'https://colizone.ecotrack.dz',
    color: '#0891B2',
    modes: ['domicile'],
    logo: 'https://cdn.kiostore.net/file/kiostore/delivery/colizone-express.jpg',
    logoHeight: 32,
  },
  {
    id: 'Navex',
    name: 'Navex',
    apiSlug: 'navexdelivery',
    apiBase: 'https://navexdelivery.ecotrack.dz',
    color: '#059669',
    modes: ['domicile', 'bureau'],
    logo: 'https://cdn.kiostore.net/file/kiostore/delivery/logo.png',
  },
  {
    id: 'Fast Delivery',
    name: 'Fast Delivery',
    apiSlug: 'fastdelivery',
    apiBase: 'https://fastdeliveryfortdz.ecotrack.dz',
    color: '#D97706',
    modes: ['domicile'],
    logo: 'https://cdn.kiostore.net/file/kiostore/delivery/imagefast.png',
    logoHeight: 32,
  },
  {
    id: 'DHD',
    name: 'DHD Livraison',
    apiSlug: 'dhd',
    apiBase: 'https://platform.dhd-dz.com',
    color: '#DC2626',
    modes: ['domicile'],
    logo: 'https://cdn.kiostore.net/file/kiostore/delivery/3_.png',
  },
  {
    id: 'Anderson',
    name: 'Anderson',
    apiSlug: 'anderson',
    apiBase: 'https://anderson-ecommerce.ecotrack.dz',
    color: '#4F46E5',
    modes: ['domicile'],
    logo: 'https://cdn.kiostore.net/file/kiostore/delivery/8_.png',
  },
  {
    id: '48HR',
    name: '48HR',
    apiSlug: '48hr',
    backendSlugAliases: ['48h-courrier-express'], // backend shipping_carrier name variant
    apiBase: 'https://48hr.ecotrack.dz',
    color: '#7C3AED',
    modes: ['domicile', 'bureau'],
    logo: 'https://cdn.kiostore.net/file/kiostore/delivery/11_.png',
  },
  {
    id: 'World Express',
    name: 'World Express',
    apiSlug: 'worldexpress',
    apiBase: 'https://world-express.ecotrack.dz',
    color: '#1D4ED8',
    modes: ['domicile'],
    logo: 'https://cdn.kiostore.net/file/kiostore/delivery/9_.png',
  },
  {
    id: 'Packers',
    name: 'Packers',
    apiSlug: 'packers',
    apiBase: 'https://packers.ecotrack.dz',
    color: '#047857',
    modes: ['domicile'],
    logo: 'https://cdn.kiostore.net/file/kiostore/delivery/12_.png',
  },
  {
    id: 'Swift',
    name: 'Swift',
    apiSlug: 'swift',
    apiBase: 'https://swift.ecotrack.dz',
    color: '#C2410C',
    modes: ['domicile'],
    logo: 'https://cdn.kiostore.net/file/kiostore/delivery/14_.png',
  },
  {
    id: 'Expedia Chrono',
    name: 'Expedia Chrono',
    apiSlug: 'expediachrono',
    apiBase: 'https://expediachrono.ecotrack.dz',
    color: '#7E22CE',
    modes: ['domicile', 'bureau'],
    logo: 'https://cdn.kiostore.net/file/kiostore/delivery/1_.png',
  },
  {
    id: 'Fret',
    name: 'Fret',
    apiSlug: 'fret',
    apiBase: 'https://fret.ecotrack.dz',
    color: '#374151',
    modes: ['domicile'],
    logo: 'https://cdn.kiostore.net/file/kiostore/delivery/10_.png',
  },
  {
    id: 'Coyote Express',
    name: 'Coyote Express',
    apiSlug: 'coyoteexpressdz',
    apiBase: 'https://coyoteexpressdz.ecotrack.dz',
    color: '#166534',
    modes: ['domicile'],
    logo: 'https://cdn.kiostore.net/file/kiostore/delivery/coyot.png',
    logoHeight: 30,
  },
  {
    id: 'RB Livraison',
    name: 'RB Livraison',
    apiSlug: 'rblivraison',
    apiBase: 'https://rblivraison.ecotrack.dz',
    color: '#7C3AED',
    modes: ['domicile'],
    logo: 'https://cdn.kiostore.net/file/kiostore/delivery/rblivraison.jpg',
    logoHeight: 30,
  },
];

/** Cards on the Livraison page. */
export function ecotrackCarriersForShipping() {
  return ECOTRACK_CARRIERS.map((c) => ({
    ...c,
    popular: false,
    apiFields: ecotrackApiFields(c.apiBase),
    dashboardUrl: `/shipping/ecotrack/${c.id}`,
  }));
}

/** Lookup map for EcotrackDashboard (`useParams().carrierId`). */
export function ecotrackDashboardRegistry() {
  return Object.fromEntries(
    ECOTRACK_CARRIERS.map((c) => [c.id, {
      name: c.name,
      apiSlug: c.apiSlug,
      apiBase: c.apiBase,
      logo: c.logo,
      color: c.color,
    }]),
  );
}

export function isEcotrackCarrierId(carrierId) {
  return ECOTRACK_CARRIERS.some((c) => c.id === carrierId);
}
